// Copyright (c) 2022 Celadon Development LLC, All rights reserved.
// Author Alexander Mikholap <alexander.mikholap@celadon.ae>

export const getLoader = state => state.voucherDetailsReducer.loading;
export const getVoucher = state => state.voucherDetailsReducer.voucher;
